class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.handleGalleryNavigation = this.handleGalleryNavigation.bind(this);
  }

  connectedCallback() {
    this.slidesScroller = this.querySelector(".bosProductGalleryItems");
    this.basicSlidesScroller = this.querySelector(
      ".bosProductGalleryBasicItems",
    );

    this.galleryActionBtns = this.querySelectorAll(
      ".bosProductGalleryContainerAction",
    );
    this.galleryActionBtns.forEach((btn) =>
      btn.addEventListener("click", this.handleGalleryNavigation),
    );

    // ── NEW: show actions on the first slide by default ──
    this.querySelector(
      '.bosProductGalleryItem[data-slide="1"] .bosProductGalleryContainerActionsContainer',
    )?.classList.add("isActive");
  }

  handleGalleryNavigation = (e) => {
    const target = e.currentTarget;
    const slideTarget = parseInt(target.dataset.slide);
    if (isNaN(slideTarget)) return;

    const totalSlides = parseInt(
      this.querySelector(".bosProductGalleryContainerActions").dataset
        .totalSlides,
    );
    if (!totalSlides) return;

    // ── NEW: move active class to only the target slide's actions ──
    this.querySelectorAll(
      ".bosProductGalleryContainerActionsContainer",
    ).forEach((container) => container.classList.remove("isActive"));
    const targetSlide = this.querySelector(
      `.bosProductGalleryItem[data-slide="${slideTarget}"]`,
    );
    targetSlide
      ?.querySelector(".bosProductGalleryContainerActionsContainer")
      ?.classList.add("isActive");
    // ── END NEW ──

    // Scroll to target slide
    const slide = this.querySelector(
      `.bosProductGalleryItem[data-slide="${slideTarget}"]`,
    );
    if (slide && this.slidesScroller) {
      this.slidesScroller.scrollTo({
        left: slide.offsetLeft - 20,
        behavior: "smooth",
      });
    }
    if (slide && this.basicSlidesScroller) {
      this.basicSlidesScroller.scrollTo({
        left: slide.offsetLeft,
        behavior: "smooth",
      });
    }

    // const currentSlideDisplay = this.querySelector(
    //   ".bosProductGalleryContainerActionsText span:first-child",
    // );
    // if (currentSlideDisplay) currentSlideDisplay.textContent = slideTarget;

    const prevSlide = slideTarget === 1 ? totalSlides : slideTarget - 1;
    const nextSlide = slideTarget === totalSlides ? 1 : slideTarget + 1;

    const prevBtn = this.querySelector(".bosProductGalleryActionPrevious");
    const nextBtn = this.querySelector(".bosProductGalleryActionNext");
    if (prevBtn) prevBtn.dataset.slide = prevSlide;
    if (nextBtn) nextBtn.dataset.slide = nextSlide;

    const actionsContainer = this.querySelector(
      ".bosProductGalleryContainerActionsContainer",
    );
    if (actionsContainer) {
      actionsContainer.classList.toggle(
        "isLastSlide",
        slideTarget === totalSlides,
      );
    }
  };
}

if (!customElements.get("product-gallery")) {
  customElements.define("product-gallery", ProductGallery);
}

class ProductInformation extends HTMLElement {
  constructor() {
    super();
    this.handleVariantSelection = this.handleVariantSelection.bind(this);
    this.handleStageChange = this.handleStageChange.bind(this);
    this.handleBottleConfiguration = this.handleBottleConfiguration.bind(this);
    this.handleShowBottleConfiguration =
      this.handleShowBottleConfiguration.bind(this);
    this.handleShowVariantStage = this.handleShowVariantStage.bind(this);
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  get sectionsToUpdate() {
    const sectionsToUpdate = this.dataset.sectionsToUpdate;
    if (!sectionsToUpdate) return [];
    return sectionsToUpdate
      .split(",")
      .map((s) => s.trim())
      .map((s) => `.${s}`);
  }

  connectedCallback() {
    document.addEventListener("product-grid:updated", () => {
      this.bindEvents();
    });
    this.bindEvents();
    this.initCircularBadgeText();
  }

  disconnectedCallback() {
    this.unbindEvents();
  }

  bindEvents() {
    this.bosVariantBtns = document.querySelectorAll(".bosVariantBtn");
    this.bosProductActionButtonStage = document.querySelectorAll(
      ".bosProductActionButtonStage",
    );
    this.bosProductActionButtonBuy = document.querySelectorAll(".bosAddToCart");

    this.bosVariantBtns.forEach((btn) => {
      btn.addEventListener("click", this.handleVariantSelection);
    });

    this.bosProductActionButtonStage.forEach((btn) => {
      btn.addEventListener("click", this.handleStageChange);
    });

    this.bottleConfigurationButtons = document.querySelectorAll(
      ".bosBottleConfigurationButton",
    );
    this.bottleConfigurationButtons.forEach((btn) =>
      btn.addEventListener("click", this.handleBottleConfiguration),
    );

    this.bosProductBottleConfigurationBottle = this.querySelector(
      ".bosProductBottleConfigurationBottle",
    );
    this.bosProductBottleConfigurationBottle?.addEventListener(
      "click",
      this.handleShowBottleConfiguration,
    );

    this.bosBottleConfigurationBackButton = document.querySelector(
      ".bosBottleConfigurationBackButton",
    );
    this.bosBottleConfigurationBackButton?.addEventListener(
      "click",
      this.handleShowVariantStage,
    );

    this.updateBottleButtons();
  }

  unbindEvents() {
    this.bosVariantBtns?.forEach((btn) => {
      btn.removeEventListener("click", this.handleVariantSelection);
    });
    this.bosProductActionButtonStage?.forEach((btn) => {
      btn.removeEventListener("click", this.handleStageChange);
    });
    this.bottleConfigurationButtons?.forEach((btn) =>
      btn.removeEventListener("click", this.handleBottleConfiguration),
    );
  }

  handleShowVariantStage() {
    const bosBottleConfiguration = document.querySelector(
      ".bosBottleConfiguration",
    );
    bosBottleConfiguration?.classList.add("hidden");

    const bosProductVariants = document.querySelector(".bosProductVariants");
    bosProductVariants?.classList.remove("hidden");

    const bosVariantStageHeader = document.querySelector(
      ".bosVariantStageHeader",
    );
    bosVariantStageHeader?.classList.remove("hidden");
  }

  handleShowBottleConfiguration() {
    const bosBottleConfiguration = document.querySelector(
      ".bosBottleConfiguration",
    );
    bosBottleConfiguration?.classList.remove("hidden");

    const bosProductVariants = document.querySelector(".bosProductVariants");
    bosProductVariants?.classList.add("hidden");

    const bosVariantStageHeader = document.querySelector(
      ".bosVariantStageHeader",
    );
    bosVariantStageHeader?.classList.add("hidden");
  }

  updateBottleButtons() {
    const selectedVariantBtn = this.querySelector(
      ".bosVariantBtn.variantIsSelected",
    );
    const isBottle = selectedVariantBtn?.dataset.isBottle === "true";

    const secureBtn = document.querySelector(
      ".bosProductActionButton.bosAddToCart:not(.bosBottleConfigurationButton)",
    );
    const bottleBtn = document.querySelector(
      ".bosProductActionButton:not(.bosAddToCart)",
    );

    // Target the two buttons inside bosProductActionButtonsFinal
    const finalContainer = document.querySelector(
      ".bosProductActionButtonsFinal",
    );
    if (!finalContainer) return;

    const secureCaskBtn = finalContainer.querySelector(".bosAddToCart");
    const bottleCaskBtn = finalContainer.querySelector(
      ".bosBtn:not(.bosAddToCart)",
    );

    if (isBottle) {
      secureCaskBtn?.classList.add("hidden");
      bottleCaskBtn?.classList.remove("hidden");
    } else {
      secureCaskBtn?.classList.remove("hidden");
      bottleCaskBtn?.classList.add("hidden");
    }
  }

  handleBottleConfiguration(e) {
    const bosBottleConfigurationModal = document.querySelector(
      ".bosBottleConfigurationModal",
    );
    const target = e.currentTarget;
    const currentState = target.dataset.currentState;

    const bosBottleConfiguration = document.querySelector(
      ".bosBottleConfiguration",
    );

    if (currentState === "inactive") {
      bosBottleConfigurationModal?.classList.remove("hidden");
      target.dataset.currentState = "active";
      bosBottleConfiguration?.classList.add("hidden");
      this.bosProductBottleConfigurationBottle?.classList.add("hidden");
    } else {
      bosBottleConfigurationModal?.classList.add("hidden");
      target.dataset.currentState = "inactive";
      bosBottleConfiguration?.classList.remove("hidden");
      this.bosProductBottleConfigurationBottle?.classList.remove("hidden");
    }
  }

  handleStageChange(e) {
    const target = e.currentTarget;

    if (target.hasAttribute("data-is-not-auth-state")) return;
    
    const currentStage = target?.dataset.buyStage;
    const otherStage = target?.dataset.otherStage;
    if (!currentStage || !otherStage) return;


    document
      .querySelectorAll(`[data-buy-stage="${currentStage}"]`)
      .forEach((el) => el.classList.add("hidden"));
    document
      .querySelectorAll(`[data-buy-stage="${otherStage}"]`)
      .forEach((el) => el.classList.remove("hidden"));
  }

  handleVariantSelection(e) {
    const target = e.currentTarget;
    this.bosVariantBtns?.forEach((btn) =>
      btn.classList.remove("variantIsSelected"),
    );
    target.classList.add("variantIsSelected");

    const variantId = target.dataset.variantId;
    if (!variantId) return;

    if (this.bosProductActionButtonBuy) {
      this.bosProductActionButtonBuy.forEach(
        (btn) => (btn.dataset.productId = variantId),
      );
    }
    this.handleSelectedVariantChange(variantId);
    this.updateBottleButtons();
  }

  handleSelectedVariantChange(variantId) {
    const sectionId = this.sectionId;
    if (!sectionId) return;

    const url = new URL(window.location.href);
    url.searchParams.set("sections", sectionId);
    url.searchParams.set("variant", variantId);

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        this.unbindEvents();
        this.renderSection(data[this.sectionId], this.sectionsToUpdate);
        url.searchParams.delete("sections");
        window.history.pushState({}, "", url.toString());
        this.setStage("2");
        this.bindEvents();
        this.updateBottleButtons();
      })
      .catch((err) => console.error(err));
  }

  setStage(targetStage) {
    document
      .querySelectorAll("[data-buy-stage]")
      .forEach((el) => el.classList.add("hidden"));
    document
      .querySelectorAll(`[data-buy-stage="${targetStage}"]`)
      .forEach((el) => el.classList.remove("hidden"));
  }

  renderSection(html, selectors) {
    const temp = document.createElement("div");
    temp.innerHTML = html;

    selectors.forEach((selector) => {
      const target = document.querySelector(selector);
      const source = temp.querySelector(selector);
      if (target && source) {
        target.innerHTML = source.innerHTML;
      }
    });
  }

  initCircularBadgeText() {
    document.querySelectorAll(".bosProductBarrelBadge").forEach((badge) => {
      const text = badge.dataset.circularText;
      if (!text || badge.querySelector(".bosCircularText")) return;

      const style = getComputedStyle(badge);
      const totalW = badge.offsetWidth;
      const totalH = badge.offsetHeight;
      const cx = totalW / 2;
      const cy = totalH / 2;
      const r = Math.min(cx, cy) - 4;
      const id = `bosCirclePath-${Math.random().toString(36).slice(2, 7)}`;

      // Measure how much of the circumference the text occupies (as a %)
      // We place text1 at 0% and text2 at 50%, each starting at top
      // A spacer character (or gap offset) separates them
      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("viewBox", `0 0 ${totalW} ${totalH}`);
      svg.setAttribute("width", totalW);
      svg.setAttribute("height", totalH);
      svg.classList.add("bosCircularText");

      svg.innerHTML = `
      <defs>
        <path id="${id}" d="M ${cx},${cy - r} a ${r},${r} 0 1,1 -0.01,0" />
      </defs>
      <text>
        <textPath href="#${id}" startOffset="0%">${text}</textPath>
      </text>
      <text>
        <textPath href="#${id}" startOffset="50%">${text}</textPath>
      </text>
    `;

      badge.appendChild(svg);
    });
  }
}

if (!customElements.get("product-information")) {
  customElements.define("product-information", ProductInformation);
}

class MeasurementTable extends HTMLElement {
  constructor() {
    super();
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.handleOpenTable = this.handleOpenTable.bind(this);
  }

  connectedCallback() {
    this.bosBarrelMeasureTableHeaderButton = this.querySelectorAll(
      ".bosBarrelMeasureTableHeaderButton",
    );
    if (this.bosBarrelMeasureTableHeaderButton.length > 0) {
      this.bosBarrelMeasureTableHeaderButton.forEach((btn) =>
        btn.addEventListener("click", this.handleLocationChange),
      );
    }

    this.bosBarrelMeasureTableHeaderTitle = document.querySelector(
      ".bosBarrelMeasureTableHeaderTitle",
    );
    if (this.bosBarrelMeasureTableHeaderTitle) {
      this.bosBarrelMeasureTableHeaderTitle.addEventListener(
        "click",
        this.handleOpenTable,
      );
    }
  }

  disconnectedCallback() {}

  handleOpenTable(e) {
    this.bosBarrelMeasureTableHeaderTitle?.classList.toggle("isActive");

    this.bosBarrelMeasurementTable = document.querySelector(
      ".bosBarrelMeasurementTable",
    );
    this.bosBarrelMeasurementTable?.classList.toggle("hidden");

    this.bosMeasurementTableSvg = document.querySelector(
      ".bosMeasurementTableSvg",
    );
    this.bosMeasurementTableSvg?.classList.toggle("isActive");

    this.bosBarrelMeasureTableHeaderButtons = document.querySelector(
      ".bosBarrelMeasureTableHeaderButtons",
    );
    this.bosBarrelMeasureTableHeaderButtons?.classList.toggle("hidden");

    this.bosBarrelMeasurementTableDetails = this.querySelector(
      ".bosBarrelMeasurementTableDetails",
    );
    this.bosBarrelMeasurementTableDetails?.classList.toggle("hidden");

    if (this.bosBarrelMeasureTableHeaderTitle?.classList.contains("isActive")) {
      this.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }

  handleLocationChange(e) {
    const target = e.currentTarget;
    if (!target) return;

    const currentLocation = target.dataset.location;

    if (currentLocation === "US") {
      this.showContent("UK", "US");
    } else {
      this.showContent("US", "UK");
    }
  }

  showContent(toShow, toHide) {
    const elementsToShow = document.querySelectorAll(
      `[data-location='${toShow}']`,
    );
    elementsToShow.forEach((element) => element.classList.remove("hidden"));
    const elementsToHide = document.querySelectorAll(
      `[data-location='${toHide}']`,
    );
    elementsToHide.forEach((element) => element.classList.add("hidden"));
  }
}

if (!customElements.get("measurement-table")) {
  customElements.define("measurement-table", MeasurementTable);
}
